import auth from './auth'
import booking from './booking'
import address from './address'
import payment from './payment'
import reset from './reset'
import order from './order'

const model = {
  auth,
  booking,
  address,
  payment,
  reset,
  order,
}

export default model
